import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { RmsModifyFlagTypes, RmsModifyFlagActions } from '../actions/rms-modify-flag.actions';

export interface RmsModifyState {
  modifyFlag: boolean;
  availableScheduleFlag: boolean;
}

export const initialState: RmsModifyState = {
  modifyFlag: false,
  availableScheduleFlag: true,
};

export function reducer(state = initialState, action: RmsModifyFlagActions | OrderBuilderActions): RmsModifyState {
  switch (action.type) {
    case RmsModifyFlagTypes.RMS_MODIFY_FLAG: {
      return {
        ...state,
        modifyFlag: true,
      } as RmsModifyState;
    }
    case RmsModifyFlagTypes.SCHEDULE_AVAILABLE_FLAG: {
      return {
        ...state,
        availableScheduleFlag: action.payload,
      } as RmsModifyState;
    }
    case RESET_BUILDER:
    case RmsModifyFlagTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
